import { useDispatch, useSelector } from 'react-redux';
import isEqual from 'lodash/isEqual';

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = useDispatch;
export const useAppSelector = (fn, opt) => useSelector(fn, opt ?? isEqual);
